import { useState } from 'react';
import MobileSignIn from './MobileSignIn';
import VerificationCode from './VerificationCode'


const MobileLogin = () => {

    const [isVerified, setIsVerified] = useState<boolean>(false)
    const [phoneNumberClient, setPhoneNumber] = useState<string>('')

    const handleNumber = (e : any) => {

        setPhoneNumber(e)
    }

    // This component will be rendered if the user already entered his phone number
    if(isVerified){
        return (
            <VerificationCode phoneNumber={phoneNumberClient}/>
        )
    }
    return (
        <MobileSignIn setIsVerified={setIsVerified} phoneNumberClient={phoneNumberClient} handleNumber={handleNumber}/>
    )
}

export default MobileLogin